import { Input, InputProps } from "..";
import * as S from "../input.styles";

export const InputText = ({
  disabled,
  label,
  placeholder,
  value,
  register,
  onChange,
  maxLength,
  name,
  type = "text",
  errors,
  step,
  necessary,
}: InputProps) => {
  return (
    <Input disabled={disabled}>
      <>
        {label && (
          <S.InputLabelBox>
            {label && label} {necessary && <span className="necessary">*</span>}
          </S.InputLabelBox>
        )}
        <S.InputTypeBox>
          <input
            type={type}
            name={name}
            {...register}
            disabled={disabled}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            step={step}
            maxLength={maxLength}
          />
        </S.InputTypeBox>
        {errors ? <p className="err-message">{errors[name!]?.message}</p> : ""}
      </>
    </Input>
  );
};
